export default __webpack_public_path__ + "static/media/eye.d8063717.svg";